import {
  createFileRoute,
  redirect,
} from "@tanstack/react-router";

// The root path (`/`) is the app's entry. We no longer ship the template
// marketing landing — visitors land directly on the sign-in page.
export const Route = createFileRoute("/_web/")({
  beforeLoad: () => {
    throw redirect({ to: "/sign-in" });
  },
});
